import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "MappingFieldsConfig",
  data: () => ({
    createMappingFieldDialog: false,
    newMappingFieldText: "",
    newMappingFieldWinter: false,
    newMappingFieldSummer: false,
    editMappingFieldDialog: false,
    editedMappingField: {}
  }),
  mounted() {
    this.$store.dispatch("getMappingFields");
  },
  methods: {
    async saveNewMappingField() {
      const foundDuplicate = this.mappingFields.find(
        field => field.title === this.newMappingFieldText
      );
      if (foundDuplicate && foundDuplicate.title) {
        alert("Mappingfeld ist bereits vorhanden");
        this.newMappingFieldText = "";
      } else {
        const newMappingField = {
          title: this.newMappingFieldText,
          summer: this.newMappingFieldSummer,
          winter: this.newMappingFieldWinter
        };
        const headers = getTokenHeader();
        try {
          const response = await axios.post(
            `${env.poi_api_client_url}mappingfields`,
            newMappingField,
            {
              headers
            }
          );
          if (response.status === 201) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
          } else {
            await this.$store.dispatch("createError", {
              errorMessage:
                "Update mappingField failed with statusCode: " + response.status
            });
          }
          await this.$store.dispatch("getMappingFields");
          this.createMappingFieldDialog = false;
          this.newMappingFieldText = "";
        } catch (error) {
          await this.$store.dispatch("createError", {
            errorMessage: "Update mappingField failed!"
          });
        }
      }
    },
    editMappingField(item) {
      this.editedMappingField = item;
      this.editMappingFieldDialog = true;
    },
    async deleteMappingField(item) {
      const confirm = await this.$confirm(
        `Wollen Sie das Mappingfeld wirklich löschen?`,
        confirmWarningConfig
      );
      if (confirm) {
        try {
          const headers = getTokenHeader();
          const response = await axios.delete(
            `${env.poi_api_client_url}mappingfields/${item._id}`,
            { headers }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
            await this.$store.dispatch("getMappingFields");
          }
        } catch (e) {
          await this.$store.dispatch("createError", {
            errorMessage: "Update mappingField failed!"
          });
        }
      }
    },
    async updateMappingField() {
      const headers = getTokenHeader();
      try {
        const response = await axios.put(
          `${env.poi_api_client_url}mappingfields`,
          this.editedMappingField,
          {
            headers
          }
        );
        await this.$store.dispatch("getMappingFields");
        this.editedMappingField = {};
        this.editMappingFieldDialog = false;
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        } else
          await this.$store.dispatch("createError", {
            errorMessage:
              "Update mappingField failed with statusCode: " + response.status
          });
      } catch (error) {
        await this.$store.dispatch("createError", {
          errorMessage: "Update mappingField failed!"
        });
      }
    }
  },
  computed: {
    mappingFields() {
      return this.$store.state.mappingFields;
    }
  }
};
